import React from 'react';
import { Link } from 'react-router-dom';


export default function Project4() {
  return (
    <div className="project1-text">
      <div className="mx-auto pt-5 px-6">

        <h1 className="text-4xl font-bold pb-3">
          The Cocktail Selector
        </h1>

        <p className="md:text-xl max-w-3xl mx-auto pb-3">
          React application that retrieves cocktail data from a third-party API
          and presents users with dynamically generated drink information.
        </p>

        <p className="project-tech">
          JavaScript • React • REST API • HTML • CSS
        </p>


        <h2 className="text-2xl font-bold pt-8 pb-3">
          Project Overview
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          The Cocktail Selector is a web application built with React that
          allows users to explore cocktail recipes and related information
          retrieved from an external API.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          What I Built
        </h2>

        <div className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          <ul className="list-disc pl-8 space-y-3">
            <li>
              React-based user interface with reusable components.
            </li>

            <li>
              Integration with a third-party REST API for dynamic cocktail data.
            </li>

            <li>
              JavaScript logic for retrieving, processing, and presenting API
              responses.
            </li>

            <li>
              Responsive interface built with HTML and CSS.
            </li>

            <li>
              State management for user interaction and dynamically loaded
              content.
            </li>

            <li>
              Git and GitHub workflows for source control and project
              development.
            </li>
          </ul>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Development Experience
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          This project provided experience working with asynchronous API
          requests, structured external data, component-based frontend
          architecture, and state-driven interfaces in React.
        </p>


        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://github.com/swanmac/The-Cocktail-Selector"
              target="_blank"
              rel="noopener noreferrer"
            >
              View GitHub Repository
            </a>
          </h3>

          <h3 className="pt-5">
            <Link to="/projects">
              Back to Projects
            </Link>
          </h3>
        </div>

      </div>

    
    </div>
  );
}